import nl from '../localization/nl.json';
import en from '../localization/en.json';
import de from '../localization/de.json';
import fr from '../localization/fr.json';
import es from "../localization/es.json"
import React, { createContext, useContext, useState } from 'react';

type TranslationType = { [key: string]: string };
type TranslationsFunction = (text: string) => string;

const enTranslations = en as TranslationType;
const deTranslations = de as TranslationType;
const frTranslations = fr as TranslationType;
const spTranslations = es as TranslationType;
const nlTranslations: TranslationType = {
  ...nl,
  english: 'Engels',
  german: 'Duits',
  french: 'Frans',
  spanish: 'Spaans',
  dutch: 'Nederlands',
  add: 'Toevoegen',
  appointment: 'Afspraak',
  appointments: 'Afspraken',
  'appointment.calendar': 'Afsprakenkalender',
  'button.cancel': 'Annuleren',
  'button.save': 'Opslaan',
  calendar: 'Kalender',
  'calendar.slots': 'Kalender en tijdsloten',
  cancel: 'Annuleren',
  'choose.day': 'Kies een dag',
  date: 'Datum',
  day: 'Dag',
  'day.month.year': 'Dag/Maand/Jaar',
  'exceptional.opening': 'Uitzonderlijke opening',
  friday: 'Vrijdag',
  from: 'Van',
  monday: 'Maandag',
  'new.closings': 'Nieuwe sluiting',
  'new.opening': 'Nieuwe opening',
  'opening.hours': 'Openingstijden',
  saturday: 'Zaterdag',
  save: 'Opslaan',
  'sidebar.calendar': 'Kalender',
  sunday: 'Zondag',
  thursday: 'Donderdag',
  to: 'Tot',
  today: 'Vandaag',
  tuesday: 'Dinsdag',
  wednesday: 'Woensdag',
  'weekly.appointments': 'Wekelijkse afspraken',
  'label.walk_in': 'Zonder afspraak',
};

export const getTranslationValues = (key: string): string[] =>
  [enTranslations, deTranslations, spTranslations, frTranslations, nlTranslations]
    .map((dictionary) => dictionary[key])
    .filter((value) => typeof value === 'string');

interface TranslationContextType {
  translations: TranslationsFunction;
  currentLang: string;
  setAppLanguage: (lang: string) => void;
}

const TranslationContext = createContext<TranslationContextType>({
  translations: () => '',
  currentLang: 'en',
  setAppLanguage: () => { },
});

export const useTranslation = () => useContext(TranslationContext);

export const TranslationProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentLang, setCurrentLang] = useState<string>(localStorage.getItem('lang') || 'en');

  const setAppLanguage = (lang: string) => {
    localStorage.setItem('lang', lang);
    setCurrentLang(lang);
  };

  // const translations: TranslationsFunction = (text) => {
  //   return enTranslations[text] === undefined && deTranslations[text] === undefined
  //     ? text
  //     : currentLang === 'en' || deTranslations[text] === undefined
  //       ? enTranslations[text]
  //       : deTranslations[text];
  // };
  const translations: TranslationsFunction = (text) => {
    if (
      enTranslations[text] === undefined &&
      deTranslations[text] === undefined &&
      frTranslations[text] === undefined
    ) {
      return text;
    }

    if (currentLang === 'de') {
      return deTranslations[text] ?? enTranslations[text] ?? text;
    }

    if (currentLang === 'fr') {
      return frTranslations[text] ?? enTranslations[text] ?? text;
    }

    if (currentLang === 'es') {
      return spTranslations[text] ?? enTranslations[text] ?? text;
    }

    if (currentLang === 'nl') {
      return nlTranslations[text] ?? enTranslations[text] ?? text;
    }

    return enTranslations[text] ?? text;
  };


  return (
    <TranslationContext.Provider value={{ translations, currentLang, setAppLanguage }}>
      {children}
    </TranslationContext.Provider>
  );
};
